module.exports = __webpack_public_path__ + "static/leonie-d53f6047c00b27a34fd896191eb80bc5.jpg";